import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as liveLessonState from './state/live-lesson-state.reducer';
import { EffectsModule } from "@ngrx/effects";
import { LiveLessonStateEffects } from "./effects/live-lesson-state.effects";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(liveLessonState.featureKey, liveLessonState.reducer),
        EffectsModule.forFeature(LiveLessonStateEffects),
    ],
})
export class LiveLessonSharedDataAccessCallStateModule {}
